import React from 'react';
import Highlight from '../Highlight/Highlight.jsx';
import SearchSuggestionsNosto from '../SearchSuggestions/SearchSuggestionsNosto.jsx';
import { recordSearchClick, recordViewProduct } from '@utils/nostoTracking.js';

const SearchFlyoutNosto = ({
    suggestions,
    handleSuggestionClick,
    results,
    query,
    collections = [],
    pages = [],
    loading = false,
    searched = false,
    redirect = null,
}) => {


    // Handle product click attribution
    const handleProductClick = (product) => {
        // Record search click analytics for search flyout
        if (product?.productId && product?.url) {
            console.log('🔍 SearchFlyoutNosto Debug - Calling recordSearchClick:', {
                type: 'autocomplete',
                productId: product.productId,
                url: product.url,
                productName: product.name || product.productName
            });

            const response = recordSearchClick('autocomplete', {
                productId: product.productId,
                url: `${window.location.origin}${product.url.startsWith('/') ? product.url : '/' + product.url}`
            });

            console.log('🔍 SearchFlyoutNosto Debug - recordSearchClick response:', response);
        }

    };
    // Filter out products with [hidden] in title, out of stock products, and limit to first 8 for better flyout performance
    const filteredResults = results?.filter(product => {
        // Filter out products with [hidden] in title
        if (product.name?.toLowerCase().includes('[hidden]')) {
            return false;
        }

        // Filter out products marked as OutOfStock
        if (product.availability === 'OutOfStock') {
            return false;
        }

        // Filter out products where all SKUs have zero inventory (only for Monica + Andy apparel products)
        if (product.brand === 'Monica + Andy' && product.skus && product.skus.length > 0) {
            const hasInventory = product.skus.some(sku =>
                sku.inventoryLevel && sku.inventoryLevel > 0
            );
            if (!hasInventory) {
                return false;
            }
        }

        return true;
    }) || [];
    const limitedResults = filteredResults.slice(0, 8);

    const formatRedirectText = (url) => {
        if (!url) return '';

        if (url.includes('/collections/')) {
            const handle = url.split('/collections/')[1].split('/')[0];
            return handle
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }

        return url.split('/').pop().replace(/_/g, ' - ');
    };

    return (
        <div className='search-flyout-outer w-full h-full'>
            <div className='search-flyout-inner wrap-md mx-auto'>
                <div className='flyout-sections-outer pt-2 pb-6 w-full overflow-y-auto'>
                    <div className='flyout-sections-inner flex flex-col md:flex-row gap-2 md:gap-6 w-full font-akkurat px-4 lg:px-0'>
                    <div className='flyout-section flyout-section-outer suggestions-section lg:w-1/4 mt-0 mb-2 md:mt-1 md:mb-4'>
                            <SearchSuggestionsNosto
                                suggestions={suggestions}
                                handleSuggestionClick={handleSuggestionClick}
                                query={query}
                            />

                        </div>
                        <div className='flyout-section flyout-section-outer products-section w-full w-3/4 mt-1 mb-4'>
                            <h3 className='flyout-section-title text-web-s3-section-content font-bold mb-3 flex items-center'>
                                Top Products
                                <a
                                    href={`/search/${query}`}
                                    className='view-all text-web-l1-link-1 underline cursor-pointer ml-auto'
                                >
                                    View All
                                </a>
                            </h3>
                            {loading ? (
                                <div className='loading-state'>
                                    <p className='font-normal text-flint text-sm'>
                                        Searching...
                                    </p>
                                </div>
                            ) : searched && query && limitedResults.length === 0 ? (
                                <div className='no-results'>
                                    <p className='font-normal text-flint text-sm'>
                                        No results found
                                    </p>
                                </div>
                            ) : (
                                <div className="products-grid grid grid-cols-2 gap-4 md:grid-cols-4">
                                    {limitedResults.map((product) => (
                                        <div key={product.productId} className="product-item">

                                            <a
                                                href={`/products/${product.url.split('/').pop().split('_')[0]}?variant=${product.skus?.find(sku => sku.inventoryLevel > 0)?.id || product.skus?.[0]?.id || ''}`}
                                                className="block"
                                                onClick={() => handleProductClick(product)}
                                            >
                                                <div
                                                    className="aspect-[2/3] flex items-center justify-center mb-2"
                                                    style={{ backgroundColor: product.brand === 'Monica + Andy' ? '#f8f8f8' : '#ffffff' }}
                                                >
                                                    <img
                                                        src={product.imageUrl}
                                                        alt={product.name}
                                                        className="w-full h-full object-contain"
                                                        loading="lazy"
                                                    />
                                                </div>
                                                <p className="text-web-s4-section-content leading-snug line-clamp-2 overflow-hidden">
                                                    <Highlight search={query}>
                                                        {product.name.replace(/_/g, ' - ')}
                                                    </Highlight>
                                                </p>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchFlyoutNosto;
